export const TCSD_WORKFLOW_TAG_NAME = "tcsd_workflow_enabled";
export const TCSD_WORKFLOW_ELEMENT_TYPE = "tcsd_workflow";

export const TCSD_WORKFLOWS = Object.freeze([
  ["request-access", "REQUEST ACCESS"],
  ["request-access-other-teacher", "REQUEST ACCESS FOR TEACHER"],
  ["invite-teacher-to-platform", "INVITE TEACHER"],
  ["send-account-setup-link", "SEND ACCOUNT SETUP LINK"],
  ["send-password-reset-link", "SEND PASSWORD RESET LINK"],
  ["update-user-email", "UPDATE USER EMAIL"],
  ["activate-teacher-account", "ACTIVATE TEACHER ACCOUNT"],
  ["resolve-login-issue", "RESOLVE LOGIN ISSUE"],
  ["rename-user", "RENAME USER"],
  ["offer-to-add-teacher", "OFFER TO ADD TEACHER"],
  ["request-invoice", "REQUEST INVOICE"],
  ["create-class", "CREATE CLASS"],
  ["remove-class", "REMOVE CLASS"],
  ["rename-class", "RENAME CLASS"],
  ["assign-screener", "ASSIGN SCREENER"],
  ["assign-alpaca-lead", "ASSIGN ALPACA LEAD"],
  ["extend-trial", "REQUEST TRIAL EXTENSION"],
  ["merge-classes", "MERGE CLASSES"],
  ["remove-teacher-assignment", "REMOVE TEACHER ASSIGNMENT"],
  ["request-early-platform-access", "REQUEST SCREENING WINDOW ACCESS"],
  ["trial-access-status", "TRIAL ACCESS HELP"],
  ["add-child", "ADD CHILD"],
  ["remove-child", "REMOVE CHILD"],
  ["fix-duplicate-child", "FIX DUPLICATE CHILD"],
  ["fix-duplicate-results", "FIX DUPLICATE RESULTS"],
  ["fix-duplicate-child-results", "REPORT CHILD RESULTS ISSUE"],
  ["restore-child-results", "RESTORE CHILD RESULTS"],
  ["swap-students-results", "SWAP STUDENTS RESULTS"],
  ["move-transfer-children", "MOVE CHILDREN"],
  ["update-teacher-roles", "UPDATE TEACHER ROLES"],
  ["remove-colleague-access", "REMOVE COLLEAGUE ACCESS"],
  ["remove-teacher-from-school", "REMOVE TEACHER FROM SCHOOL"],
  ["send-whatsapp-group-invite", "GET WHATSAPP INVITE"],
  ["provide-login-bypass", "PROVIDE LOGIN BYPASS"],
  ["make-results-visible", "REQUEST RESULTS ACCESS"],
  ["export-assessment-data", "ALADDIN EXPORT"],
  ["escalate-technical-issue", "CONTACT SUPPORT"],
  ["offer-meeting", "OFFER MEETING"],
  ["screening-guidance-resources", "SEARCH HELP AND GUIDANCE"],
  ["escalate-feature-request", "SUGGEST AN IMPROVEMENT"],
  ["reset-task", "RESET TASK"],
  ["classroom-transition", "CLASSROOM TRANSITION"]
].map(([id, label], index) => Object.freeze({ number: index + 1, id, label })));
